<script>
    export default {
        props: {
            productId: null,
            productStatuses: null,
            productStatus: null,
            storeUrl: null,
            readOnly: false,
        },
        data() {
            return {
                productStatusMutable: this.productStatus,
            }
        },
        watch: {
            productStatusMutable: function (status) {
                if (!this.readOnly) {
                    this.saveStatus();
                }
            }
        },
        methods: {
            saveStatus() {
                axios.put(this.storeUrl, {
                    'product_id': this.productId,
                    'status_id': this.productStatusMutable,
                }).then(() => {
                    window.location.reload();
                });
            },
        }
    }
</script>

<template>
    <div>
        <select class="form-control" style="margin-top: 11px" v-model="productStatusMutable" :disabled="readOnly">
            <option value="0" selected disabled>Status auswählen</option>
            <option :value="status.id" v-for="status in productStatuses">{{ status.name }}</option>
        </select>
    </div>
</template>